import { render } from "./ErrorComponent.vue?vue&type=template&id=7761cf85&scoped=true"
import script from "./ErrorComponent.vue?vue&type=script&lang=js"
export * from "./ErrorComponent.vue?vue&type=script&lang=js"

import "./ErrorComponent.vue?vue&type=style&index=0&id=7761cf85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7761cf85"],['__file',"src/components/ErrorComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7761cf85"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7761cf85', __exports__)) {
    api.reload('7761cf85', __exports__)
  }
  
  module.hot.accept("./ErrorComponent.vue?vue&type=template&id=7761cf85&scoped=true", () => {
    api.rerender('7761cf85', render)
  })

}


export default __exports__